// extracted by mini-css-extract-plugin
module.exports = {"container":"CardList_container__3vJxk","card_grid":"CardList_card_grid__2vTPK","card_bg":"CardList_card_bg__3F1os"};